// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23YSm","placeholdersHeader":"styles_placeholdersHeader__2iNqH","editorStyle":"styles_editorStyle__3crE4","placeholdersBox":"styles_placeholdersBox__rW87r"};